import React, { useRef } from "react";
import SelectInput from "../SelectInput/SelectInput";
import styles from './AnotherRentalItem.module.scss'
import cn from 'classnames'
import { Country, Lang } from "../../../types/common-types";
import { State, Dispatch, actions } from '../../../state-actions-reducers'
import TextInput from "../TextInput/TextInput";
import PhoneInput from "../PhoneInput/PhoneInput";
import accountForm from "../../../content/account-form";
import DeleteButton from "../../../shared/Buttons/DeleteButton";
import FileInput from '../../../shared/Inputs/FileInput/FileInput'
import { UPLOADS_ENDPOINT } from "../../../server-parameters";
import NumberInput from "../NumberInput/NumberInput";

interface Props {
    lang: Lang;
    state: State;
    invalidFields: (string | false)[];
    dispatch: Dispatch;
    index: number
    disabled: boolean
    deleteHandler: () => void
}

export default function AnotherRentalsItem({ lang, state, invalidFields, dispatch, index, disabled, deleteHandler }: Props) {
    return <div className={cn('row', styles.rentals_row)}>
        <div className={'col-4 col-xs-12'}>
            <TextInput
                testName={`rentals-${index}`}
                testErrorName={`error-rentals-${index}`}
                lang={lang}
                content={accountForm.anotherRentalName}
                onChange={(e) => {
                    dispatch({
                        type: actions.RENTALS,
                        data: index < state.rentals.length
                            ? state.rentals.map((item, i) => {
                                return (index === i) ? {
                                    rentalName: e,
                                    rentalDiscount: state.rentals[index]?.rentalDiscount,
                                    rentalDataFile: state.rentals[index]?.rentalDataFile,
                                } : item
                            }) : state.rentals.concat({
                                rentalName: e,
                                rentalDiscount: state.rentals[index]?.rentalDiscount,
                                rentalDataFile: state.rentals[index]?.rentalDataFile,
                            })
                    })
                }}
                value={state.rentals[index]?.rentalName}
                valid={!invalidFields.includes(`rentalsName${index}`)}
                disabled={disabled}
            />
        </div>
        <div className={'col-4 col-xs-12'}>
            <NumberInput
                testName={`rentals-${index}`}
                testErrorName={`error-rentals-${index}`}
                lang={lang}
                content={accountForm.anotherRentalDiscount}
                onChange={(e) => {
                    dispatch({
                        type: actions.RENTALS,
                        data: index < state.rentals.length
                            ? state.rentals.map((item, i) => {
                                return (index === i) ? {
                                    rentalName: state.rentals[index]?.rentalName,
                                    rentalDiscount: e,
                                    rentalDataFile: state.rentals[index]?.rentalDataFile,
                                } : item
                            }) : state.rentals.concat({
                                rentalName: state.rentals[index]?.rentalName,
                                rentalDiscount: e,
                                rentalDataFile: state.rentals[index]?.rentalDataFile,
                            })
                    })
                }}
                value={state.rentals[index]?.rentalDiscount}
                valid={!invalidFields.includes(`rentalsDiscount${index}`)}
                disabled={disabled}
            />
        </div>
        <div className={'col-4 col-xs-12'}>
            <FileInput
                disabled={!state.agreed}
                lang={lang}
                url={UPLOADS_ENDPOINT}
                autorization={state.formId}
                target={state.rentals[index]?.rentalDataFile || {}}
                content={accountForm.anotherRentalFile}
                dispatch={dispatch}
                isSingleMode={true}
                onChange={(fileData) => {
                    dispatch({
                    type: actions.RENTALS,
                    data: state.rentals.map((item, i) => 
                        i === index ? { 
                        ...item, 
                        rentalDataFile: fileData
                        } : item
                    )
                    });
                }}
                valid={!invalidFields.includes(`rentalsFileName${index}`)}
                documentType="0"
                value={state.rentals[index]?.rentalDataFile?.originalFileName}
                imageErrors={state.imageError}
            />
            {!(state?.rentals.length <= 1 && index === 0) ? (
                <>
                    <DeleteButton
                        testName="deleteMessenger"
                        className={styles.deleteBtn}
                        onClick={deleteHandler}
                    />
                    <button
                        data-test-id="deleteMessenger"
                        className={styles.rentalsMobileDeleteButton}
                        onClick={() => {
                            dispatch({
                                type: actions.RENTALS,
                                data: state.rentals.filter((e, i) => {
                                    return i !== index
                                })
                            })
                        }}
                    >
                        Удалить
                    </button>
                </>
            ) : null}
        </div>
    </div>
}